<template>
  <div class="divPage">
    <div>
      <div class="divItem">
        <b-row>
          <b-col> Status of Order:Waiting for payment</b-col>
        </b-row>
        <b-row>
          <b-col>
            Your picture has been submitted, please pay within 24 hours, overtime order will be automatically cancelled.
          </b-col>
        </b-row>
      </div>
      <div class="divItem">
        <h6>Payment for goods</h6>
        <hr />
        <b-row>
          <b-col cols="4">
            <img :src="thumbnailSrc" style="width: 64px" />
          </b-col>
          <b-col cols="5" class="rightText">Service fee</b-col>
          <b-col cols="3" class="rightText">￥100</b-col>
        </b-row>
      </div>

      <div class="divItem">
        <h6>Settle accounts</h6>
        <hr />
        <b-row>
          <b-col class="rightText">Total price：￥100</b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col class="rightText">Order number:{{ this.order }}</b-col>
        </b-row>
      </div>

      <div class="divItemNotice">
        <h6>Warm reminder</h6>
        <div>1.The above card customization information cannot be changed after payment.</div>
        <div>2.We will send you card around 20 working days, please kindly check it.</div>

        <div class="divItem">
          <b-row>
            <b-col cols="10" class="mx-auto payBtn">
              <b-button block variant="danger" @click="wxPay()" v-preventReClick
                >Wechat Pay</b-button
              >
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderPay_Dubai",
  data() {
    return {
      thumbnailSrc: "",
      order: ""
    };
  },
  methods: {
    wxPay() {
      this.toOrderResult_Dubai();
    },
    toOrderResult_Dubai() {
      this.$router.push({ name: "OrderResult_Dubai" });
    }
  },
  mounted: function() {
    this.thumbnailSrc = this.$route.params.imagePath;
    this.order = this.$route.params.order;
  }
};
</script>

<style scoped>
.payBtn {
  margin-top: 16px;
}

.replaceBtn {
  margin-top: 16px;
  margin-bottom: 24px;
}

.divItem {
  margin-top: 16px;
  background-color: white;
  padding: 8px;
}

.divItemNotice {
  margin-top: 16px;
  padding: 8px;
}

.rightText {
  text-align: right;
}

.divPage {
  background-color: #f1f2f3;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/OrderPay_Dubai.vue